import LetterBookContent from './components/LetterBookContent';
import usePage from '@monorepo/shared/src/hooks/use-page';
import { BaseHtmlRenderingProviders } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@legacy/HTMLRenderEngine';

const LetterBook: React.FC<{ letter: string; backRoute?: string; fromRoute?: string }> = ({
  letter,
}) => {
  const [{ noOfPages }] = usePage();

  return (
    <BaseHtmlRenderingProviders noOfPages={noOfPages} WordFeature={null}>
      <LetterBookContent letter={letter} />
    </BaseHtmlRenderingProviders>
  );
};

export default LetterBook;
